<template>
    <div class="container">
        <div class="skills-header" v-motion :initial="{
            opacity: 0,
            y: 100,
        }" :enter="{
            opacity: 1,
            y: 0,
        }">
            <div class="wrapper">
                <div class="skills-title">
                    I'm a Full Stack Developer !
                </div>
            </div>
            <p class="skills-description">Technologies and tools that define my professional journey. 
                <!-- <a href="https://www.fidelity.com/"
                    target="_blank" class="company-name">Fidelity Investments</a> -->
                </p>
        </div>
        <div class="skills" v-motion :initial="{
            opacity: 0,
            y: 100,
        }" :visible-once="{
            opacity: 1,
            y: 0,
        }">
            <div v-for="item in imageList" class="skill-wrapper">
                <div class="skill-card">
                    <img :key="item.name" :src="item.location" :alt="item.name" class="image" />
                </div>
                <span class="skill-tooltip">{{ item.name }}</span>
            </div>


        </div>
    </div>
</template>

<script>
import javascript from '@/assets/icons/javascript.svg';
import html from '@/assets/icons/html.svg';
import css from '@/assets/icons/css.svg';
import react from '@/assets/icons/react.svg';
import git from '@/assets/icons/git.svg';
import sveltekit from '@/assets/icons/sveltekit.png';
import vue from '@/assets/icons/vue.png';
import python from '@/assets/icons/python.png';
import nodejs from '@/assets/icons/nodejs.png';
import angular from '@/assets/icons/angular.png';
import aws from '@/assets/icons/aws.png';
import mysql from '@/assets/icons/mysql.svg';
import graphqlLogo from '@/assets/icons/graphql-logo.svg'

export default {
    name: 'SkillsComponent',
    data() {
        return {
            imageList: [
                { location: javascript, name: 'Javascript' },
                { location: html, name: 'Html' },
                { location: css, name: 'Css' },
                { location: vue, name: 'Vue' },
                { location: react, name: 'React' },
                { location: git, name: 'Git' },
                { location: sveltekit, name: 'Sveltekit' },
                { location: python, name: 'Python' },
                { location: nodejs, name: 'Node JS' },
                { location: angular, name: 'Angular' },
                { location: graphqlLogo, name: 'GraphQL' },
                { location: mysql, name: 'MySql' },
                { location: aws, name: 'AWS' },

            ],
        }
    },
    methods: {
        getImageUrl(location) {
            return require(`${location}`);
        },
    }
}
</script>

<style scoped>
.container {
    background-color: var(--primary-bg-color);
    padding: 120px;
    display: flex;
    gap: 48px;
    flex-direction: column;
}

.wrapper {
    height: 100%;
    display: grid;
    place-items: center;
}

.typing-demo {
    width: 18ch;
    animation: typing 2s steps(25), blink .5s step-end infinite alternate;
    white-space: nowrap;
    overflow: hidden;
    border-right: 3px solid;
    /* font-family: monospace; */
}

@keyframes typing {
    from {
        width: 0
    }
}

@keyframes blink {
    50% {
        border-color: transparent
    }
}

.skills-header {
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-align: center;
}

.skills-title {
    font-size: 2rem;
    font-weight: 700;
}

.skills-description {
    font-size: 1.2rem;
    color: var(--secondary-text-color)
}

.company-name {
    background: linear-gradient(134.15deg, #B66BE1, #FF6267, #FFA84B);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.skills {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 24px;
    column-gap: 70px;
}

.skills img {
    width: 50px;
    height: 50px;
}

.skill-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.skill-card {
    border-radius: 50%;
    border: 1px solid #252626;
    background: #0C0C0D;
    display: flex;
    padding: 0.9rem;
    align-items: center;
    transition: all 0.3s ease-in-out;
}

.skill-card:hover {
    box-shadow: 6px 5px 8px #B66BE1;
    transform: scale(1.05);
}

.skill-tooltip {
    position: absolute;
    bottom: calc(100% + 12px);
    left: 50%;
    transform: translate(-50%, 6px);
    padding: 6px 12px;
    border-radius: 8px;
    background: #1A1A1C;
    border: 1px solid #B66BE1;
    color: var(--primary-text-color);
    font-size: 0.85rem;
    font-weight: 500;
    white-space: nowrap;
    pointer-events: none;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
    z-index: 10;
}

.skill-tooltip::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: #B66BE1;
}

.skill-wrapper:hover .skill-tooltip {
    opacity: 1;
    visibility: visible;
    transform: translate(-50%, 0);
}


@media (max-width: 700px) {
    .container {
        padding: 32px;
    }

    .skills {
        column-gap: 20px;
        row-gap: 28px;
    }

    .skills img {
        width: 32px;
        height: 32px;
    }

    .skills-title {
        font-size: 1.2rem;
    }

    .skills-description {
        font-size: 1rem;
    }

    .skill-wrapper {
        gap: 0.4rem;
    }

    .skill-card {
        padding: 0.7rem;
    }

    .skill-tooltip {
        position: static;
        transform: none;
        opacity: 1;
        visibility: visible;
        font-size: 0.65rem;
        font-weight: 400;
        padding: 0;
        background: transparent;
        border: none;
        color: var(--secondary-text-color);
    }

    .skill-tooltip::after {
        content: none;
    }
}
</style>